import api from './client';
let entity = 'push';

export const subscribe = async (subscription) => {
  const { data } = await api.post(`/${entity}/subscribe`, subscription);
  return data;
};

export const unsubscribe = async (endpoint) => {
  const { data } = await api.post(`/${entity}/unsubscribe`, { endpoint });
  return data;
};

export const sendTest = async () => {
  const { data } = await api.post(`/${entity}/test`);
  return data;
};